<template>
  <!--UPLOADING DETAILS-->
  <div
    tabindex="0"
    class="wrapper-1 bg-white pos-relative remaining-space fill-width d-flex flex-column "
    :class="[
      isShowUploadingDetails ? 'upload-details-open' : 'upload-details-close',
      this.$vuetify.breakpoint.width > 768 ? 'w-420' : '',
      screenType !== 'desktop' && 'uploading-details-open-mobile',
    ]"
  >
    <!--TITLE-->
    <div
      v-if="isInMiddleOfFiltering && screenType === 'desktop'"
      class="d-flex bg-grey pa-3"
      :class="[!isShowUploadingDetails ? 'wrapper-1 mb-2' : 'title-border']"
    >
      <v-icon
        @click="isShowUploadingDetails = !isShowUploadingDetails"
        class="pointer"
        large
        :aria-label="`${isShowUploadingDetails ? 'open' : 'close'} Settings`"
        >mdi-chevron-{{ isShowUploadingDetails ? 'down' : 'right' }}</v-icon
      >
      <h3 class="font-weight-medium fs-1-5r">{{ $t('Details') }}&nbsp;</h3>
    </div>

    <!--CONTENT OF THE UPLOADING FIELD-->
    <div :class="[screenType !== 'desktop' && 'steps-wrapper-mobile',screenType !== 'desktop' && 'remaining-space']">
      <Recipients
        v-if="isShowUploadingDetails"
        :session="session"
        :userActiveSourceRoutes="userActiveSourceRoutes"
        :lightSessionRestart="lightSessionRestart"
        :screenType="screenType"
        :activeTab="activeTab"
        :isShowUploadingDetails="isShowUploadingDetails"
        :continueButtonClicked="continueButtonClicked"
        :verifiedEmails="verifiedEmails"
        :pushToVerifiedEmailsList="pushToVerifiedEmailsList"
      />

      <SelectFiles
        :session="session"
        :filteringErrMessage="filteringErrMessage"
        :startFilteringClicked="startFilteringClicked"
        :restartSessionClicked="restartSessionClicked"
        :lightSessionRestart="lightSessionRestart"
        :screenType="screenType"
        :setIsShowFilteringErrMessage="v => (isShowFilteringErrMessage = v)"
        :setIsShowUploadingDetails="v => (isShowUploadingDetails = v)"
      />

      <Progress
        :filteringProgress="filteringProgress"
        :timer="timer"
        :session="session"
        :screenType="screenType"
        :isInMiddleOfFiltering="isInMiddleOfFiltering"
      />

      <Results
        :restartSessionClicked="restartSessionClicked"
        :statusResults="statusResults"
        :screenType="screenType"
        :uploadStep="uploadStep"
        :session="session"
        :filteringErrMessage="filteringErrMessage"
        :startFilteringClicked="startFilteringClicked"
        :isShowFilteringErrMessage="isShowFilteringErrMessage"
        :isShowUploadingDetails="isShowUploadingDetails"
        :setIsShowFilteringErrMessage="v => (isShowFilteringErrMessage = v)"
        :setIsShowUploadingDetails="v => (isShowUploadingDetails = v)"
      />
    </div>

    <!--MESSAGE WHY DOWNLOAD BUTTON IS DISABLED-->
    <div
      v-if="screenType === 'desktop'"
      class="red--text d-flex align-center"
      :class="computedHeight"
    >
      <Transition name="slide-fade">
        <span
          v-if="isShowFilteringErrMessage"
          class="mx-auto fs-1-25r text-center"
        >
          {{ filteringErrMessage }}
        </span>
      </Transition>
    </div>

    <!--START-RESTART BUTTONS-->
    <StartRestartButtons
      v-if="screenType === 'desktop'"
      :session="session"
      :filteringErrMessage="filteringErrMessage"
      :setIsShowFilteringErrMessage="v => (isShowFilteringErrMessage = v)"
      :startFilteringClicked="startFilteringClicked"
      :restartSessionClicked="restartSessionClicked"
      :setIsShowUploadingDetails="v => (isShowUploadingDetails = v)"
      :buttonText="$t('Start')"
      :screenType="screenType"
    />
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

//Children
import StartRestartButtons from './Children/StartRestartButtons/StartRestartButtons.vue'
import CasualSend from '@/components/WebsiteInterface/CommonComponents/CasualSend/CasualSend.vue'
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import UploadingDetailsFields from '@/components/WebsiteInterface/CommonComponents/UploadingDetailsFields/UploadingDetailsFields.vue'
import Button from '@/components/BaseComponents/Button/Button.vue'
import Recipients from './Children/Steps/Recipients.vue'
import SelectFiles from '@/components/WebsiteInterface/WebsiteInterfaceDesktop/Childern/UploadDesktop/Children/UploadingDetails/Children/Steps/SelectFiles.vue'
import Progress from './Children/Steps/Progress.vue'
import Results from './Children/Steps/Results.vue'

export default {
  name: 'UploadingDetails',
  data() {
    return {
      isShowFilteringErrMessage: false,
      isShowUploadingDetails: true,
      isShowContinueBtn: false,
    }
  },
  props: {
    session: Object,
    userActiveSourceRoutes: Array,
    filteringErrMessage: String,
    startFilteringClicked: Function,
    restartSessionClicked: Function,
    lightSessionRestart: Function,
    activeTab: Object,
    screenType: String,

    filteringProgress: Object,
    timer: Number,

    statusResults: Object,
    verifiedEmails: Array,
    pushToVerifiedEmailsList: Function,
  },
  watch: {
    session: {
      handler: function (n, o) {
        this.updateIsShowContinueBtn()
        // this.updateIsShowContinueBtn2()
      },
      deep: true,
    },
    isInMiddleOfFiltering(n) {
      if (n === true && this.screenType === 'desktop')
        this.isShowUploadingDetails = false
      else if (n === false) {
        this.isShowFilteringErrMessage = false
        this.isShowUploadingDetails = true
      }
    },
    // 'session.selectedRoute': {
    //   handler: function (n) {
    //     console.log('selectedRoute changed in UploadingDetails.vue')
    //     if (!n && this.session) this.session.interfaceDynamicFields = undefined
    //     else if (n) {
    //       console.log(n)
    //       this.session.interfaceDynamicFields = JSON.parse(
    //         JSON.stringify(n.interfaceDynamicFields)
    //       )
    //       this.$forceUpdate()
    //     }
    //   },
    // },
    // 'activeTab.tab': {
    //   handler: function (n) {
    //     if (n === 'casual') {
    //       if (this.loggedUser.role === 'SuperAdmin') {
    //         this.activeTab.tab = 'regular'
    //         return
    //       }
    //       console.log('casual tab selected')
    //       this.session.interfaceDynamicFields = JSON.parse(
    //         JSON.stringify(this.loggedUser.interfaceDynamicFieldsForRegistered)
    //       )
    //       console.log('session.interfaceDynamicFields:', this.session)()
    //     }
    //     if (n === 'regular') {
    //       console.log('registered tab selected')
    //       if (
    //         this.loggedUser.role != 'Individual' &&
    //         this.loggedUser.role != 'SuperAdmin' &&
    //         !this.userActiveSourceRoutes.length
    //       )
    //         this.activeTab.tab = 'casual'
    //       else this.session.interfaceDynamicFields = []
    //     }
    //   },
    // },
  },
  components: {
    StartRestartButtons,
    CasualSend,
    StepForMobile,
    UploadingDetailsFields,
    Button,
    Recipients,
    SelectFiles,
    Progress,
    Results,
  },

  computed: {
    ...mapGetters([
      'isInMiddleOfFiltering',
      'accessibility',
      'loggedUser',
      'uploadStep',
    ]),

    isShowTabs() {
      const isShowCasuals = this.loggedUser.isAllowCasuals
      const isShowRegistered = this.userActiveSourceRoutes.length > 0
      if (!isShowCasuals || !isShowRegistered) {
        const el = document.getElementsByClassName('v-slide-group')
        if (el && el.length && el[1]) el[1].style.display = 'none'
        return false
      } else {
        const el = document.getElementsByClassName('v-slide-group')
        if (el && el.length && el[1]) el[1].style.display = ''
      }

      return true
    },

    // isShowTabInMobile() {
    //   console.log(this.uploadStep)
    //   if (this.screenType !== 'desktop' && this.uploadStep !== 1) {
    //     const el = document.getElementsByClassName('v-slide-group')
    //     if (el && el.length) {
    //       for (let i = 0; i < el.length; i++) {
    //         el[i].style.display = 'none'
    //       }
    //     }
    //     return false
    //   }
    //   return true
    // },
    computedHeight() {
      if (this.accessibility.fontSize === 1) return 'h-30'
      else if (this.accessibility.fontSize === 1) return 'h-50'
      else return 'h-80'
    },
  },
  methods: {
    ...mapMutations(['SET_UPLOAD_STEP']),
    continueButtonClicked(step) {
      this.SET_UPLOAD_STEP(this.uploadStep + 1)
      // this.updateIsShowContinueBtn2()
      this.updateIsShowContinueBtn()
      if (this.uploadStep === 3) {
        this.startMobileFiltering()
      }
      console.log('this.uploadStep', this.uploadStep)
      // this.$forceUpdate()
    },
    updateIsShowContinueBtn(val) {
      if (this.screenType !== 'mobile' || this.uploadStep !== 1) {
        this.isShowContinueBtn = false
        return
      }
      if (
        this.loggedUser.role === 'Individual' ||
        this.loggedUser.role === 'SuperAdmin'
      ) {
        if (this.session.policy) {
          this.isShowContinueBtn = true
          return
        } else {
          this.isShowContinueBtn = false
          return
        }
      } else {
        if (
          this.session.selectedRoute &&
          ((this.activeTab.tab === 'regular' &&
            this.session.selectedUsers?.length) ||
            (this.activeTab.tab === 'casual' &&
              this.session.selectedCasualUsers?.length)) &&
          (this.session.interfaceDynamicFields?.length
            ? this.session.interfaceDynamicFields
                ?.filter(df => df.required)
                .every(df => df.value)
            : true)
        ) {
          console.log('continue button shown')
          this.isShowContinueBtn = true
          return
        } else {
          this.isShowContinueBtn = false
          return
        }
      }
    },
  },
}
</script>

<style scoped src="./UploadingDetails.css"></style>

<style scoped>
.v-tabs >>> .v-window {
  /* min-height: 300px !important; */
  overflow: visible;
  /* overflow-y: auto !important */
}
</style>
